import { useNavigate } from 'react-router-dom';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const LOGO_TEXT = "https://customer-assets.emergentagent.com/job_precision-connect/artifacts/lvo1u53w_image.png";

const links = [
  { label: 'Protocolo', href: '/protocolo' },
  { label: 'Empresas', href: '/empresa' },
  { label: 'Advisors', href: '/advisor' },
];

export default function Footer() {
  const sectionRef = useScrollAnimation();
  const navigate = useNavigate();

  return (
    <footer
      ref={sectionRef}
      data-testid="footer-section"
      className="bg-[#1B2A4A] py-20 md:py-24 relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-4">
            <div className="fade-up">
              <img
                src={LOGO_TEXT}
                alt="Conadvy"
                className="h-14 md:h-16 mb-6 object-contain"
                data-testid="footer-logo"
              />
              <p className="text-[#8A9BB1] text-sm leading-relaxed max-w-xs">
                El ecosistema donde las mejores decisiones
                empiezan por las personas.
              </p>
            </div>
          </div>

          {/* Nav */}
          <div className="md:col-span-3 md:col-start-7">
            <div className="fade-up fade-up-delay-1">
              <span className="text-[#C58C40] text-xs font-medium tracking-[0.2em] uppercase block mb-5">
                Navegación
              </span>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.href}>
                    <button
                      onClick={() => navigate(link.href)}
                      data-testid={`footer-nav-${link.href.replace('/', '')}`}
                      className="text-[#8A9BB1] text-sm hover:text-white transition-colors duration-300"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <div className="fade-up fade-up-delay-2">
              <span className="text-[#C58C40] text-xs font-medium tracking-[0.2em] uppercase block mb-5">
                Contacto
              </span>
              <ul className="space-y-3">
                <li>
                  <a
                    href="mailto:contacto@conadvy.com"
                    data-testid="footer-email"
                    className="text-[#8A9BB1] text-sm hover:text-white transition-colors duration-300"
                  >
                    contacto@conadvy.com
                  </a>
                </li>
                <li className="text-[#8A9BB1] text-sm">
                  Valencia, España
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="fade-up h-[1px] w-full bg-white/10 mb-8" />
        <div className="fade-up fade-up-delay-1 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#8A9BB1]/50 text-xs">
            &copy; {new Date().getFullYear()} Conadvy. Made with discretion.
          </p>
          <div className="flex gap-6">
            <button
              onClick={() => navigate('/legal')}
              data-testid="footer-legal"
              className="text-[#8A9BB1]/50 text-xs hover:text-white/50 transition-colors"
            >
              Aviso Legal
            </button>
            <button
              onClick={() => navigate('/privacidad')}
              data-testid="footer-privacy"
              className="text-[#8A9BB1]/50 text-xs hover:text-white/50 transition-colors"
            >
              Privacidad
            </button>
            <button
              onClick={() => navigate('/terminos')}
              data-testid="footer-terms"
              className="text-[#8A9BB1]/50 text-xs hover:text-white/50 transition-colors"
            >
              Términos
            </button>
            <button
              onClick={() => navigate('/cookies')}
              data-testid="footer-cookies"
              className="text-[#8A9BB1]/50 text-xs hover:text-white/50 transition-colors"
            >
              Cookies
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
